
import { createApp } from 'vue'
import App from '@/App.vue'
import axios from 'axios'
import elementPlus from 'element-plus'
import 'element-plus/dist/index.css'


const app = createApp(App)
app.config.globalProperties.$http = axios
app.use(elementPlus)
app.mount('#app')
